"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE = exports.CUSTOM_DROPDOWN_MULTI_COLUMN = exports.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES = exports.CUSTOM_DROPDOWN_COMMODITIES = void 0;
/* istanbul ignore file */

const CUSTOM_DROPDOWN_INTELLIGENCE_PAGES = exports.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES = 'IntelligencePages';
const CUSTOM_DROPDOWN_MULTI_COLUMN = exports.CUSTOM_DROPDOWN_MULTI_COLUMN = 'MultiColumnDropDown';
const CUSTOM_DROPDOWN_COMMODITIES = exports.CUSTOM_DROPDOWN_COMMODITIES = 'CommoditiesDropDown';
const CUSTOM_DROPDOWN_NEW_HOME_TOGGLE = exports.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE = 'NewHomeToggle';

// export type TMainNavMenuMapMultiColumns